import React from 'react';
import gql from 'graphql-tag';
import { useLazyQuery } from '@apollo/client';

interface OptionsProps {
  queryString: string;
  variables?: object;
  children?: any;
  dataMapCallback?: Function;
  withDebounceMS: number;
  canExecuteQuery: Boolean;
}

interface RenderProps {
  loading?: boolean;
  error?: object;
  data?: object;
}

let ttimeOutPointer: Timeout = false;

const ApolloOptionsQuery = ({
  queryString,
  variables,
  dataMapCallback,
  children,
  withDebounceMS,
  canExecuteQuery,
}: OptionsProps) => {
  const [theQuery, { data, loading, error }] = useLazyQuery(gql(queryString));

  if (canExecuteQuery && withDebounceMS > 0) {
    if (ttimeOutPointer) clearTimeout(ttimeOutPointer);
    ttimeOutPointer = setTimeout(() => {
      theQuery({ variables });
    }, withDebounceMS);
  } else if (canExecuteQuery) {
    theQuery({ variables });
  }

  return React.Children.map(children, (child: any) =>
    React.cloneElement(
      child,
      dataMapCallback
        ? dataMapCallback({ error, loading, data })
        : dataMapCallback
    )
  );
};

ApolloOptionsQuery.defaultProps = {
  variables: {},
  children: {},
  withDebounceMS: 0,
  canExecuteQuery: true,
  dataMapCallback: ({ error = '', loading = false }) => ({
    items: [{ label: '', value: '' }],
    error,
    loading,
    queryError: {},
  }),
};

export default ApolloOptionsQuery;
try {
    // @ts-ignore
    apolloOptionsQuery.displayName = "apolloOptionsQuery";
    // @ts-ignore
    apolloOptionsQuery.__docgenInfo = { "description": "", "displayName": "apolloOptionsQuery", "props": { "queryString": { "defaultValue": null, "description": "", "name": "queryString", "required": true, "type": { "name": "string" } }, "variables": { "defaultValue": { value: "{}" }, "description": "", "name": "variables", "required": false, "type": { "name": "object" } }, "dataMapCallback": { "defaultValue": { value: "({ error = '', loading = false }) => ({\n    items: [{ label: '', value: '' }],\n    error,\n    loading,\n    queryError: {},\n  })" }, "description": "", "name": "dataMapCallback", "required": false, "type": { "name": "Function" } }, "withDebounceMS": { "defaultValue": { value: 0 }, "description": "", "name": "withDebounceMS", "required": false, "type": { "name": "number" } }, "canExecuteQuery": { "defaultValue": { value: true }, "description": "", "name": "canExecuteQuery", "required": false, "type": { "name": "Boolean" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/hoc/apolloWrapper/apolloOptionsQuery.tsx#apolloOptionsQuery"] = { docgenInfo: apolloOptionsQuery.__docgenInfo, name: "apolloOptionsQuery", path: "src/hoc/apolloWrapper/apolloOptionsQuery.tsx#apolloOptionsQuery" };
}
catch (__react_docgen_typescript_loader_error) { }